import { render, staticRenderFns } from "./vpsFooter.vue?vue&type=template&id=41132b41&scoped=true"
import script from "./vpsFooter.vue?vue&type=script&lang=js"
export * from "./vpsFooter.vue?vue&type=script&lang=js"
import style0 from "./vpsFooter.vue?vue&type=style&index=0&id=41132b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41132b41",
  null
  
)

export default component.exports